import qs from 'query-string'
import useSWR from 'swr'

import { IPlan } from '../types'
import createRestClient from './createRestClient'
import useOrganization from './useOrganization'

export default function usePlan(planName: string | null | undefined) {
  const organization = useOrganization()

  const { data, error } = useSWR<IPlan | null>(
    () => {
      if (!planName) {
        throw new Error('plan name was not available')
      }

      if (organization?.stripeCustomerId === undefined) {
        throw new Error('customerId was not available')
      }

      return qs.stringifyUrl(
        {
          url: `plan/${planName}`,
          query: { customer: organization.stripeCustomerId },
        },
        { skipNull: true },
      )
    },
    async (url: string) => {
      const data = await createRestClient().get<{
        selectedPlan: IPlan
      }>(url)

      if (!data || !data.selectedPlan) {
        return null
      }

      return data.selectedPlan
    },
  )

  if (error) {
    throw error
  }

  if (planName === null) {
    return null
  }

  return data
}
